module.exports = __webpack_public_path__ + "media/images/ic_parking-089bcc0a83257f399839d10a1c24cd8c.svg";